import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { datePipe, getRandomColorWithOpacity, yAxisformateValue } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';
import { bottom } from '@popperjs/core';
import { ChartOptions } from 'chart.js';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';

@Component({
  selector: 'piqet-angular-report-slides',
  templateUrl: './report-slides.component.html',
  styleUrls: ['./report-slides.component.scss'],
})
export class ReportSlidesComponent implements AfterViewInit, OnChanges {
  @Input() reportData: any;
  chartId: any;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';
  counterMaterial = 1;
  counterMaterialSecond: any;
  counterMaterialThird: any;
  baseScenario: any;
  baseTotal: any;
  isShowGraphicalSummary = false;
  baseTotalSecond: any = [];
  scenarioTotal: any = [];
  indicators: any = [];
  unit: any = [];
  equivalancyUnitlist: any;
  totalImpact: any = [];
  equivalentImpact: any = [];
  imagelist: any = [];
  spiderChartData: any = [];
  spiderChartLabels: string[] = [];
  barChartData: any = [];
  indicatorNamesList: any = [];
  mbarChartLabels: string[] = [];
  allBarChartDara: any = [];
  barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      x: {
        ticks: {
          font: {
            size: 16, // Adjust the font size as needed
          },
          padding: 10,
        },
      },
      y: {
        ticks: {
          font: {
            size: 16, // Adjust the font size as needed
          },
          callback: (value: any, index: any, values: any) => {
            const valueFormat =
              value.toString().includes('e') || value.toString().includes('E')
                ? value.toExponential(2)
                : yAxisformateValue(value);
            return valueFormat;
          },
        },
        beginAtZero: true,
        title: {
          display: true, // Set your Y-axis label here
          text: '',
          font: {
            size: 16,
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            // Generated to access once chart is created. DO NOT REMOVE
          },
        },
      },
      legend: {
        display: true,
        position: bottom,
        padding: 10,
        labels: {
          usePointStyle: true, // Set to true for circular legends
        },
      },
    },
  };
  spiderChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
      },
    },
    scales: {
      // y: {
      //   beginAtZero: true
      // },
      r: {
        alignToPixels: true,
        pointLabels: {
          display: false, // Hide point labels
        },
        ticks: {
          display: true, // Hide tick marks
          count: 3,
        },
      },
    },
    layout: {
      padding: {
        top: 100,
        right: 200,
        left: 150,
        bottom: 60,
      },
    },
  };
  doughnutChartPlugins = [
    {
      id: 'custom_labels',
      afterDraw: (chart: any, args: any) => {
        var image = new Image();
        // require for development When it will finished will remove
        // image.src = "https://piqet-angular.ifour-consultancy.net/assets/images/Piqet_NewLogo.png";
        if (image.complete) {
          const scale = chart.scales['r'];
          let counter = 0;
          for (const lable in this.spiderChartLabels) {
            this.drawTextAtIndex(
              this.chartImage[counter],
              scale,
              counter,
              this.spiderChartLabels[lable],
              counter
            );
            counter++;
          }
          // drawTextAtIndex(scale, 1, '3d_rotation', 'test1');
          // drawTextAtIndex(scale, 2, 'done', 'test2');
        } else {
          image.onload = () => chart.draw();
        }
      },
    },
  ];
  componentItems: any;
  chartImage: any;
  parentArr: any = [];
  componentItemsArray: any;
  @ViewChild('targetDivRef', { static: false }) targetDivRef!: ElementRef;
  @Output() checkContent = new EventEmitter<{ projectName: any }>();
  indicatorsName: any;
  valueArray: any;
  totalImpactValue: any;
  equivalentImpactValues: any;

  constructor(private projectService: ProjectsService) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkContent.emit({ projectName: this.reportData.projectName });
    }, 1000);
  }

  async ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    this.unit =
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.length > 0
        ? this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].numberofUnits
        : 0;
    this.checkValues();
    this.getValuesAndData();
    this.baseScenario = this.reportData.spiderChartItems.scenarioListForAnnumImpact.find(
      (data: any) => data.scenarioname == this.reportData.baseScenarioFullName
    );
    // this.baseScenario = this.reportData.spiderChartItems.scenarioListForAnnumImpact.find((data: any) => { return data.scenarioname == this.reportData.baseScenarioFullName });
    this.baseTotal = !!this.baseScenario ? this.baseScenario.totals.split(';') : null;
    this.equivalancyUnitlist =
      this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].indicatorEquivalancyUnits.split(
        ';'
      );
    this.getRemainingText();
    this.getScenarioTotal();
    this.componentItemsArray = this.reportData.spiderChartItems.scenarioList;
    const holdingArr: any = [];
    if (this.reportData.spiderChartItems?.scenarioList?.length > 0) {
      this.componentItems = this.splitterFunc(
        this.reportData.spiderChartItems.scenarioList[0].indicators
      );
    }
    for (let i = 0; i < this.componentItems.length; i++) {
      holdingArr.push([]);
    }
    this.parentArr = holdingArr;
    this.spiderChartLabels = this.componentItems;
    let chartData = await this.GetSpiderChart();
    this.spiderChartData = chartData;
    this.valueArray = this.reportData.indicatorIds.split(',');
    this.barChartGenerate(this.reportData.indicatorIds);
  }

  barChartGenerate(data: any) {
    const valuesArray = data.split(',');
    if (valuesArray.length <= 2) {
      this.isShowGraphicalSummary = false;
    }
    valuesArray.map((x: any, i: any) => {
      const payload = {
        scenarioIds: this.reportData.scenarioIds,
        reportFormatId: 2,
        reportTypeId: 14,
        baseScenarioId: 0,
        chartImpactCategoryId: 7,
        imapctCategoryId: 0,
        indicatorIds: this.reportData.indicatorIds,
        impactTypeIds: '',
        charttypeId: 2,
        functionalUnitId: this.reportData.functionUnitId,
        projectId: this.reportData.projectId,
        isExport: true,
        isExportPdf: true,
        isSlideDetailsReport: true,
        indicatorIdd: valuesArray[i],
        isExcludeProductImpacts: false,
        IndicatorId: '',
      };
      this.projectService.generateBarChart(payload).subscribe((res: any) => {
        if (res) {
          const response = res.data;
          this.indicatorsName = response.indicatorName;
          this.componentItemsArray = response?.componentItems;
          const holdingArr: any = [];
          if (response?.componentItems?.length > 0) {
            this.componentItems = this.splitterFunc(response?.componentItems[0].componentName);
          }
          for (let i = 0; i < this.componentItems.length; i++) {
            holdingArr.push([]);
          }
          this.parentArr = holdingArr;
          this.mbarChartLabels = this.componentItems;
          let datas = this.convertToMultiArr();
          this.barChartData = datas.data.reverse();
          this.indicatorNamesList.push(datas.indicatorName);
          this.allBarChartDara.push(this.barChartData);
          for (let i = 0; i < this.indicatorNamesList.length; i++) {
            this.barChartOptions.scales.y.title.text = this.indicatorNamesList[i];
          }
        }
      });
    });
  }

  convertToMultiArr() {
    let data: any = [];
    let indicatorName = '';
    this.componentItemsArray.forEach((ele: any, i: any) => {
      const randomColor = getRandomColorWithOpacity(0.1);
      let addObj: any = [];
      var valuesArray = ele.impactValues.split(';');
      var percentArray = ele.percentage.split(';').map((x: any) => parseFloat(x).toFixed(2));
      addObj = {
        data: valuesArray,
        label: ele.name,
        stack: 'a',
        percent: percentArray,
        borderWidth: {
          top: 1, // Set the border width for the top side
          right: 0, // Set the border width for the right side
          bottom: 0, // Set the border width for the bottom side
          left: 0, // Set the border width for the left side
        },
        borderSkipped: false,
      };
      if (ele.name != 'Total') {
        addObj['backgroundColor'] = randomColor[i].rgba;
        addObj['borderColor'] = randomColor[i].rgb;
        addObj['pointBackgroundColor'] = randomColor[i].rgba;
        addObj['pointBorderColor'] = randomColor[i].rgb;
        data.push(addObj);
      }
      indicatorName = ele.indicators;
    });
    return { data: data, indicatorName: indicatorName };
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }

  GetSpiderChart() {
    let data: any = [];
    this.componentItemsArray.forEach((ele: any, i: any) => {
      let addObj: any = [];
      const randomColor = getRandomColorWithOpacity(0.1);
      var valuesArray = ele.totals.split(';');
      this.chartImage = ele.indicatorImageName.split(';');
      addObj = {
        data: valuesArray,
        label: ele.scenarioname,
        backgroundColor: randomColor[i].rgba,
        borderColor: randomColor[i].rgb,
        borderWidth: '1.4',
        pointBackgroundColor: randomColor[i].rgba,
        pointBorderColor: randomColor[i].rgb,
      };
      data.push(addObj);
    });
    return data;
  }

  getValuesAndData() {
    this.reportData.spiderChartItems.scenarioListForAnnumImpact.map((data: any, index: any) => {
      this.imagelist.push(data.equivalencyImageTable.split(';'));
      data.indicators.split(';').map((x: any, indexOfX: any) => {
        if (
          this.baseTotalSecond.length > 0 &&
          data.totals.split(';').length > 0 &&
          this.baseTotalSecond.length > index
        ) {
          this.totalImpact.push(
            ((Number(this.baseTotalSecond[index][indexOfX]) * this.unit -
              Number(data.totals.split(';')[indexOfX]) * this.unit) /
              (Number(this.baseTotalSecond[indexOfX]) * this.unit)) *
              100
          );
        }
        if (this.baseTotalSecond.length > 0 && this.baseTotalSecond.length > index) {
          this.equivalentImpact.push(
            (Number(this.baseTotalSecond[index][indexOfX]) * this.unit -
              Number(data.totals.split(';')[indexOfX]) * this.unit) *
              Number(data.multiplier.split(';')[indexOfX])
          );
        }
      });
    });
  }

  getTotalImpactValue(index: any, comparetotal: any) {
    const unit =
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.length > 0
        ? this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].numberofUnits
        : 0;
    if (this.baseTotal.length > 0 && comparetotal.length > 0) {
      this.totalImpactValue =
        ((parseFloat(comparetotal[index]) * unit) / (parseFloat(this.baseTotal[index]) * unit)) *
        100;
      if (parseFloat(this.baseTotal[index]) == 0) {
        this.totalImpactValue = 0;
      }
    }
    return this.totalImpactValue;
  }

  getEquivalentImpactValue(index: any, comparetotal: any, multiplier: any) {
    const unit =
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.length > 0
        ? this.reportData.spiderChartItems.scenarioListForAnnumImpact[0].numberofUnits
        : 0;
    if (this.baseTotal.length > 0) {
      this.equivalentImpactValues =
        (parseFloat(this.baseTotal[index]) * unit - parseFloat(comparetotal[index]) * unit) *
        parseFloat(multiplier[index]);
    }
    const value = Math.round(Math.abs(this.equivalentImpactValues));
    return value;
  }

  getTotalImpact() {
    return Math.round(Math.abs(this.totalImpactValue));
  }

  drawTextAtIndex(imageSrc: any, scale: any, index: any, text: any, counter: any) {
    const image = new Image();
    image.src = imageSrc;
    const offset = 48;
    const r = scale.drawingArea + offset;
    const angle = scale.getIndexAngle(index) - Math.PI / 2;
    const x = scale.xCenter + Math.cos(angle) * r;
    const y = scale.yCenter + Math.sin(angle) * r;
    const ctx = scale.ctx;
    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = 'center';
    ctx.font = '12px Neue Montreal, Arial, sans-serif';
    const lineHeight = 12; // Adjust this value as needed
    const lines = [];
    const words = text.split(' ');
    let currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const testLine = currentLine + ' ' + word;
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      const maxWidth = 100;

      if (testWidth <= maxWidth) {
        currentLine = testLine;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }

    lines.push(currentLine);

    // Calculate vertical position for centered text
    const textHeight = lines.length * lineHeight;
    const startY = -(textHeight / 2) + lineHeight / 2;

    if (this.spiderChartLabels.length < 15) {
      ctx.drawImage(image, -15, startY - 42, 30, 30);
    }

    ctx.fillStyle = 'black';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      ctx.fillText(line, 0, startY + i * lineHeight);
    }

    ctx.restore();
  }

  getEquivalancyname(data: any) {
    return data.substring(0, 1).toUpperCase() + data.substring(1);
  }

  checkValues() {
    if (this.reportData.spiderChartItems.scenarioListForAnnumImpact.length != 0) {
      this.reportData.spiderChartItems.scenarioListForAnnumImpact.forEach((item: any) => {
        if (item.scenarioname == this.reportData.baseScenarioFullName) {
          this.baseTotalSecond.push(item.totals.split(';'));
        }
      });
    }
  }

  getScenarioTotal() {
    this.reportData.spiderChartItems.scenarioListForAnnumImpact.map((data: any) => {
      this.scenarioTotal.push(data.totals.split(';'));
      this.indicators.push(data.indicators.split(';'));
    });
  }

  scenarioTotalShowHide(data: any, i: number) {
    if (parseFloat(data[i]) <= parseFloat(this.baseTotal[i])) {
      return true;
    } else {
      return false;
    }
  }

  getRemainingText(): string {
    const parts = this.reportData.projectName.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }

  scrollToElement() {
    const targetDivElement = this.targetDivRef.nativeElement;
    targetDivElement.scrollIntoView({ behavior: 'smooth' });
  }

  getFormateDate(date: any) {
    return datePipe(date);
  }
}
